import { FirestorePath, NameValuePair } from "@zickko/shared";
import { firestoreApi } from "../services/firestoreApi";

export class DocumentRepo<K extends NameValuePair<string>, T> {
  //
  protected firestorePath: FirestorePath<K, T>;

  constructor(firestorePath: FirestorePath<K, T>) {
    this.firestorePath = firestorePath;
  }

  template = () => {
    return this.firestorePath.template;
  };

  ref = (key: K) => {
    return firestoreApi.documentRef(this.path(key));
  };

  path = (key: K) => {
    return this.firestorePath.path(key);
  };

  get = async (key: K) => {
    return firestoreApi.getDoc<T>(this.path(key));
  };

  set = (key: K, obj: T) => {
    return firestoreApi.setDoc(this.path(key), obj);
  };

  merge = (key: K, obj: Partial<T>) => {
    return firestoreApi.mergeDoc(this.path(key), obj);
  };

  remove = (key: K) => {
    return firestoreApi.deleteDoc(this.path(key));
  };
}
